module.exports = __webpack_public_path__ + "img/tag.53cf245b.svg";